import { createContext } from 'react';

const FeatureTogglesContext = createContext();

export default FeatureTogglesContext;
